import { Component, OnInit, Input } from '@angular/core';
import { IQuestionModel } from '@care-portals/api-interfaces';
import { QuestionsCatalog } from '@care-portals/data';

@Component({
  selector: 'consultation-viewer',
  templateUrl: './consultation-viewer.component.html',
  styleUrls: ['./consultation-viewer.component.less']
})
export class ConsultationViewerComponent implements OnInit {
  @Input() questions: any[];
  @Input() data: any;
  @Input() brand: string;

  selectedQuestions: IQuestionModel[] = [];
  ngOnInit(): void {

    this.questions.map(field => {
      const question = QuestionsCatalog.find(qModel => {
        return qModel.field === field;
      });

      if (question) {
        this.selectedQuestions = [...this.selectedQuestions, question];

        const key = question.field;
        if (this.data[key] === undefined) {
          this.data = { ...this.data, [key]: {} };
          if (question.type === 'polar_check') {
            this.data[key].isNo = true;
          }
        }
      }
    });
  }
}
